<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_v"></a><em>Contents</em></h2>
<p class="tocx"><a href="#/xhtml/ser#ser">Series Editor’s Preface</a></p>
<p class="tocx"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toct"><a href="#/xhtml/chapter01#ch1">A Public Place</a></p>
<p class="toc"><a href="#/xhtml/chapter02#ch2">Birthmark</a></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">Promised Something Big</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">Failure to Eat Bread</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">Piano Box</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">A Piece of Land</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">Drawer of Knives</span></p>
<p class="toc"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">A Day Off</span></p>
<p class="toc"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample">Inheritance</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Porch People</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Snail Darter</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Mama, I Cut My Hand</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Small Ravenous Bird</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">A Large Sturdy Face</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Litanies</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Singer Woods</span></p>
<p class="toc"><a id="page_vi"></a><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">A Second Sleep</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Hospital Chairs</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Like Men Anywhere</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Going After Humbaba</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">A Shiny Black Lacquered Object</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Act of Mischief</span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Told Two Things</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">The Moon and Its Three Children</span></p>
<p class="toc"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Familiar Ground</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?20145f33